// OKX 钱包连接服务
export const walletService = {
    // 检查 OKX 钱包是否已安装
    isWalletInstalled: () => {
      return typeof window.okxwallet !== 'undefined';
    },
    
    // 连接钱包获取比特币地址
    connectWallet: async () => {
      try {
        if (!walletService.isWalletInstalled()) {
          throw new Error('OKX 钱包未安装，请先安装 OKX 钱包');
        }
        
        // 连接到 OKX 钱包的比特币网络
        const result = await window.okxwallet.bitcoin.connect();
        
        if (result && result.address) {
          // 存储连接状态和地址信息
          localStorage.setItem('walletConnected', 'true');
          localStorage.setItem('walletAddress', result.address);
          localStorage.setItem('walletPublicKey', result.publicKey || '');
          
          return { 
            connected: true,
            address: result.address,
            publicKey: result.publicKey
          };
        } else {
          throw new Error('钱包连接失败，未获取到地址');
        }
      } catch (error) {
        console.error('Wallet connection error:', error);
        throw error;
      }
    },
    
    // 断开钱包连接
    disconnectWallet: () => {
      localStorage.removeItem('walletConnected');
      localStorage.removeItem('walletAddress');
      localStorage.removeItem('walletPublicKey');
      return { connected: false, address: null, publicKey: null };
    },
    
    // 获取连接状态
    getConnectionStatus: () => {
      const connected = localStorage.getItem('walletConnected') === 'true';
      const address = localStorage.getItem('walletAddress');
      const publicKey = localStorage.getItem('walletPublicKey');
      
      return {
        connected,
        address,
        publicKey
      };
    }
  };